import { render } from "./singleGModal.vue?vue&type=template&id=47e233c7&ts=true"
import script from "./singleGModal.vue?vue&type=script&lang=ts"
export * from "./singleGModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__